import { countFragrances, isHiddenOrGwp } from './cart-toolkit'

const calculateVialCapacity = (data) => {
  let totalVialCapacity = 0

  data.items.forEach((item) => {
    if (isHiddenOrGwp(item)) {
      return
    }
    const vialsNeeded = Number(item.properties?._pura_vials_needed || 0)
    if (vialsNeeded > 0) {
      totalVialCapacity += vialsNeeded * item.quantity
    }
  })

  const totalFragrances = countFragrances(data)
  return { totalVialCapacity, totalFragrances }
}

const updateVialCapacityMessage = (data, cartUpsellHeader) => {
  if (!window.Pura?.settings?.enable_cart_fragrance) {
    cartUpsellHeader.html('You might also like')
    return
  }

  const { totalVialCapacity, totalFragrances } = calculateVialCapacity(data)
  const difference = totalVialCapacity - totalFragrances

  // Find all devices requiring vials
  const devices = data.items.filter((item) => {
    if (isHiddenOrGwp(item)) return false
    return Number(item.properties?._pura_vials_needed || 0) > 0
  })

  // Only update message if we have devices requiring vials
  let message = ''
  if (difference <= 0 || devices.length === 0) {
    message = 'You might also like'
  } else if (devices.length === 1) {
    // Use the device's title if available, otherwise product_type
    const deviceName = devices[0].title || devices[0].product_type || 'diffuser'
    message = `Almost there! Complete your ${deviceName} by adding ${difference} fragrance${
      difference !== 1 ? 's' : ''
    }.`
  } else {
    message = `Almost there! Complete your diffusers by adding ${difference} fragrance${
      difference !== 1 ? 's' : ''
    }.`
  }

  cartUpsellHeader.html(message)
}

export { calculateVialCapacity, updateVialCapacityMessage }
